// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"65":"ae9951df","92":"8435462e","740":"0c03c077","787":"3dafeb4a"}[chunkId] + ".chunk.js";
};